import { render, staticRenderFns } from "./groupChat.vue?vue&type=template&id=665b8129&"
import script from "./groupChat.vue?vue&type=script&lang=js&"
export * from "./groupChat.vue?vue&type=script&lang=js&"
import style0 from "./groupChat.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports